var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"device-container d-flex flex-column mb-3 cursor-pointer",class:{
    'device-in-focus': _vm.inFocus,
  },on:{"click":_vm.viewGroup}},[_c('div',{staticClass:"d-flex h-100 p-3"},[_c('div',{staticClass:"d-flex justify-content-center flex-column"},[_c('h2',{staticClass:"m-b-5 font-18"},[_vm._v(_vm._s(_vm.group.name))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }